import React, { Component } from "react";
import { Wrapper, Card, PrimaryButton } from "app/NativeComponents/common";
import { TextButton } from "app/NativeComponents/snippets";

class Buttons extends Component {
  render() {
    return (
      <Wrapper>
        <Card style={{ borderRadius: 30, overflow: "hidden" }}>
          <PrimaryButton formButton onPress={() => this.props.savePassword()}>
            Reset Password
          </PrimaryButton>
        </Card>
      </Wrapper>
    );
  }
}

export default Buttons;
